import { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';

import { useLicenseContext } from '../LicenseModeContext';

import { departmentOfficesToOptions } from '../../rimm/utils/rimmEntityToOption';
import { HeaderTabFields } from '../types/fieldEnums';

import { lpcoSelector, selectedLicenseTypeSelector, unionOfEditableFieldsSelector } from '../store/selectors';
import { RimmEntityType } from '../../rimm/data/rimmEntityEnums';
import { fetchRimmEntityByCode } from '../../rimm/services';

function useDepartmentOfficeOptions() {
  const { createMode } = useLicenseContext();

  const lpco = useSelector(lpcoSelector);
  const licenseType = useSelector(selectedLicenseTypeSelector);

  const editableFields = useSelector(unionOfEditableFieldsSelector);
  const departmentOfficeIsEditable = editableFields.has(HeaderTabFields.departmentOfficeCode);

  const [options, setOptions] = useState<SelectOption[]>([]);

  const ministryCode = createMode ? licenseType.data?.licenseTypeResponse?.ministryCode : lpco.data?.ministryCode;
  const departmentCode = createMode ? licenseType.data?.licenseTypeResponse?.departmentCode : lpco.data?.departmentCode;

  useEffect(() => {
    if (ministryCode && departmentCode && departmentOfficeIsEditable) {
      const getDepartmentOfficeOptions = async () => {
        try {
          const {
            data: { ministryDepartments },
          } = await fetchRimmEntityByCode({ entity: RimmEntityType.ministry, code: ministryCode });

          if (ministryDepartments.length) {
            const departmentData = ministryDepartments.find(
              (ministryDepartment) => ministryDepartment.code === departmentCode
            );

            if (departmentData) {
              const ministryDepartmentOffices = departmentData.ministryDepartmentOffices;

              const options = departmentOfficesToOptions(ministryDepartmentOffices);

              setOptions(options);
            }
          }
        } catch (e) {
          console.error(e);
        }
      };

      void getDepartmentOfficeOptions();
    }
  }, [ministryCode, departmentCode, departmentOfficeIsEditable]);

  return options;
}

export default useDepartmentOfficeOptions;
